import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DommusLoading from './componentes/DommusLoading/DommusLoading.js';

// Lazy load do componente Principal vindo do index.js
const Principal = lazy(() => import('./componentes/Principal/index.jsx'));
const Login = lazy(() => import('./componentes/Login/index.jsx'));
const Admin = lazy(() => import('./componentes/Admin/index.jsx'));
const PaginaSituacaoModulo = lazy(() => import('./componentes/PaginaSituacaoModulo/index.jsx'));
const PaginaSituacaoFuncionalidade = lazy(() => import('./componentes/PaginaSituacaoFuncionalidade/index.jsx'));
const PaginaReleases = lazy(() => import('./componentes/PaginaReleases/index.jsx'));
const PaginaIncidentes = lazy(() => import('./componentes/PaginaIncidentes/index.jsx'));

function App() {
  return (
    <Router>
      <Suspense fallback={<DommusLoading />}>
        <Routes>
          <Route path="/*" element={<Principal />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />}>
            <Route path="modulos" element={<PaginaSituacaoModulo />} />
            <Route path="funcionalidades" element={<PaginaSituacaoFuncionalidade />} />
            <Route path="releases" element={<PaginaReleases />} />
            <Route path="incidentes" element={<PaginaIncidentes />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
